import { currentLanguage, history, labels } from '../globals/config';
import { serviceDescriptionData } from './serviceDescription';
import { replacementData } from './replacements';
import { garageLocatorData } from './garageLocator';
import { vehicleSelectorData } from './vehicleSelector';
import { userInfoData } from './userInfo';
import { dateSelectorData, formatTime } from './dateSelector';
import switchStep from '../components/switchStep';
import { prepareConfirmationData } from './confirmation';
import { menaPrice } from '../../components/tools';

const $ = jQuery;
const $quoteToolContainer = $('#quote-tool');
const $appointmentTool = $('#appointment-tool');

/**
 * Summary module
 */
export function summaryModule() {
    submitModule();
}

/**
 * Generate summary
 */
export function generateSummary() {
    const garageInfo = `<span>${garageLocatorData.name}</span>
                        <span>${garageLocatorData.address}</span>
                        <span>${garageLocatorData.phone}</span>`;

    const userInfo = `<span>${userInfoData.lastname} ${userInfoData.firstname}</span>
                      <span style="text-transform: none">${userInfoData.email}</span>
                      <span>${userInfoData.phone}</span>`;

    const dateInfo = `<span>${convertDate(dateSelectorData.fullDate)}</span>
                      <span>${formatTime(dateSelectorData.time)}</span>`;

    applyData(serviceDescriptionData.name, 'service');
    applyData(replacementData.type, 'replacement');
    // Calculate total price from serviceDescriptionData
    let totalPriceFromServices = serviceDescriptionData.reduce((acc, service) => acc + service.price, 0);
    let price = totalPriceFromServices + replacementData.price;
    applyData(menaPrice(price), 'total-price');
    applyData(garageInfo, 'garage');

    const marque = vehicleSelectorData.marqueText;
    const model = vehicleSelectorData.modelText;
    let vehicle;
    if (model.includes(marque)) {
        vehicle = model;
    } else {
        vehicle = `${marque} ${model}`;
    }
    applyData(vehicle, 'vehicle');
    applyData(vehicleSelectorData.chassisNumber, 'vin');
    applyData(vehicleSelectorData.licensePlate, 'license_plate');
    applyData(vehicleSelectorData.mileage, 'license_km');

    applyData(userInfo, 'about');
    applyData(userInfoData.contactPreferenceText, 'contact_preference');
    applyData(dateInfo, 'date');

    $('#quote-tool section.active').removeClass('active');
    $(`#quote-tool section[data-step-name="summary"]`).addClass('active');
    history.push('summary');
}

/**
 * Apply data to summary.
 * @param data
 * @param field
 */
export function applyData(data, field) {
    const $field = $(`#summary-${field}`);

    if (data) {
        $field.html(data);

        $field.parent().show();
    } else {
        $field.parent().hide();
    }
}

/**
 * Convert date to locale string.
 * @param date
 * @returns {string}
 */
export function convertDate(date) {
    const inputDate = new Date(date);

    const formattedDate = inputDate.toLocaleString(currentLanguage, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return formattedDate.replace(/^./, formattedDate[0].toUpperCase());
}

function submitModule() {
    $quoteToolContainer.on('click', '.js-qt-summary--submit', function () {
        const comment = $('#summary-comment').val();
        let language = $('body').attr('data-lang-slug');
        if (!language) {
            language = 'fr';
        }
        language = language.toUpperCase();

        let totalPriceFromServices = serviceDescriptionData.reduce((acc, service) => acc + service.price, 0);
        let totalPrice = totalPriceFromServices + replacementData.price;

        let planCodes = serviceDescriptionData.map((service) => ({
            Duration: service.duration,
            ExternalId: service.apiServiceId,
        }));

        const data = {
            Assets: {
                Brand: vehicleSelectorData.marqueText,
                LicensePlate: vehicleSelectorData.licensePlate,
                Model: vehicleSelectorData.modelText,
                VIN: vehicleSelectorData.chassisNumber,
                Mileage: vehicleSelectorData.mileage,
            },
            Comments: comment,
            Contact: {
                Email: userInfoData.email,
                Name: userInfoData.firstname + ' ' + userInfoData.lastname,
                ContactPreference: userInfoData.contactPreference.toUpperCase(),
                Comments: 'Phone: ' + userInfoData.phone,
                Language: language,
                NonGdpr: !userInfoData.marketingConsent, // true if user did NOT give consent
            },
            PlanCodes: planCodes,
            DepartmentId: parseInt(garageLocatorData.departmentID),
            TimeslotId: dateSelectorData.slotId,
            TotalPrice: totalPrice,
        };

        if (vehicleSelectorData.mileage) {
            let mileage = vehicleSelectorData.mileage;

            if (!isNaN(mileage)) {
                mileage = 0;
            }

            if (mileage > 9999999) {
                mileage = 0;
            }

            data.Assets.Mileage = mileage;
        }

        let replacementSlug = 'NONE';
        if (replacementData.slug) {
            replacementSlug = replacementData.slug;
        }
        data.Service = replacementSlug;

        $.ajax({
            type: 'POST',
            url: menaObject.ajaxurl,
            dataType: 'html',
            data: {
                action: 'qtCreateOrder',
                data: data,
                garageID: garageLocatorData.garageID,
            },
            beforeSend: function () {
                $('#quote-tool').addClass('loading');
            },
            success: function (response) {
                const passed = checkAreSubmitPassed(response);

                if (passed === true) {
                    prepareConfirmationData();
                    switchStep('thank-you');
                }
                $('#quote-tool').removeClass('loading');
            },
        });
    });
}

export function checkAreSubmitPassed(response) {
    // Check if the response is already a JavaScript object
    if (typeof response === 'string') {
        // Parse the JSON string
        response = JSON.parse(response);
    }

    let generalErrorMessages = labels.generalErrorMessages;

    if (response.Message && response.Message === 'The request is invalid.') {
        alert(generalErrorMessages);
        return false;
    }

    if (response.Errors && Array.isArray(response.Errors) && response.Errors[0]) {
        let error = response.Errors[0];
        if (error.includes('Timeslot with id')) {
            alert(labels.emptyTimeSlot);
            return false;
        }

        alert(generalErrorMessages);
        return false;
    }

    return true;
}
